import * as z from "zod";
import { callerSubject } from "../subject";
import { mutator } from "./mutator";

export const testConnectorSchema = z.object({
  connectedAppId: z.string(),
});

export const testConnectedApp = mutator({
  schema: testConnectorSchema,
  resolve: {
    app: { kind: "connectedApp", from: "connectedAppId" },
  },
  permissions: [
    {
      permission: ({ args }) =>
        args.app.authorizationMode === "visitor"
          ? "connected_app:write"
          : "connected_app:use",
      scopeId: ({ args }) => args.app.id,
    },
  ],
  fn: async ({ tx, ctx, args: { app } }) => {
    await tx.mutate.connectedApps.update({
      id: app.id,
      lastTestAt: Date.now(),
      lastTestStatus: "pending",
      lastTestMessage: null,
      lastTestExecutionId: null,
      lastTestUserId:
        app.authorizationMode === "visitor"
          ? (callerSubject(ctx)?.id ?? null)
          : null,
    });
  },
});
